const features = [
  { icon: 'ri-4k-line', title: '超清画质', desc: '支持1080P至4K分辨率，HDR画质增强，每一帧都清晰锐利，带来影院级视觉享受。', color: 'primary' },
  { icon: 'ri-flashlight-line', title: '极速加载', desc: '全球CDN加速节点覆盖，智能码率自适应，无论何种网络环境都能流畅不缓冲。', color: 'accent' },
  { icon: 'ri-smartphone-line', title: '全端适配', desc: '电脑、平板、手机完美适配，无需安装App，浏览器打开即可沉浸式观影。', color: 'secondary' },
  { icon: 'ri-article-line', title: '海量片库', desc: '2.8万+高清电影大全，每日同步最新电影上线，经典与新片一网打尽。', color: 'primary' },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">平台特色</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          为什么选择萝卜影视？四大核心优势给你答案
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-6 border border-background-200/60 hover:border-primary-500/30 transition-all cursor-pointer group text-center"
            >
              <span className={`w-14 h-14 flex items-center justify-center rounded-2xl mx-auto mb-4 ${
                item.color === 'accent' ? 'bg-accent-500/15' :
                item.color === 'secondary' ? 'bg-secondary-500/15' :
                'bg-primary-500/15'
              }`}>
                <i className={`${item.icon} text-2xl ${
                  item.color === 'accent' ? 'text-accent-400' :
                  item.color === 'secondary' ? 'text-secondary-400' :
                  'text-primary-400'
                }`}></i>
              </span>
              <h3 className="text-base font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}